import production from "./environments/production-settings";
import tour from "./environments/tour-settings";
import defaultSettings from "./environments/default-settings";
import staging from "./environments/staging-settings";
import development from "./environments/development-settings";
import { FLAG_NAMES } from "./flag-constants";
import { SettingsConfig } from "./settings-type";
import { importSettings, flagIsEnabled } from "./feature-flags";
import { Environments, getEnvironmentName } from "./environment-finder";
import getEnvVariables from "lib/environmentVariables/getEnvVariables";

const environments: Record<Environments, Partial<SettingsConfig>> = {
  production,
  tour,
  staging,
  development,
  test: {},
};

importSettings(defaultSettings, environments);

export { flagIsEnabled, FLAG_NAMES, getEnvironmentName, getEnvVariables };
